import { Navigate } from 'react-router-dom';

import { RedirectWithParams } from '@/components/router/redirect-with-params';

export const requestRoutes = [
  {
    path: 'requests',
    children: [
      { index: true, element: <Navigate to="../orders/requests" replace /> },
      { path: 'list', element: <Navigate to="../orders/requests" replace /> },
      { path: 'new', element: <Navigate to="../orders/requests/new" replace /> },
      { path: ':id/edit', element: <RedirectWithParams to="../orders/requests/:id/edit" /> },
      {
        path: 'users',
        children: [
          { index: true, element: <Navigate to="../../orders/access" replace /> },
          {
            path: ':id/detail',
            element: <RedirectWithParams to="../../../orders/access/:id/detail" />,
          },
          {
            path: ':id/edit',
            element: <RedirectWithParams to="../../../orders/access/:id/edit" />,
          },
        ],
      },
    ],
  },
];
